import { render, staticRenderFns } from "./DataViewSidebarHealthFacilities.vue?vue&type=template&id=36f411bd&scoped=true&"
import script from "./DataViewSidebarHealthFacilities.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarHealthFacilities.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarHealthFacilities.vue?vue&type=style&index=0&id=36f411bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f411bd",
  null
  
)

export default component.exports